export default __webpack_public_path__ + "static/assets/701e72920ce1528819b48514d5768e34.gif";